module.exports = __webpack_public_path__ + "img/h5_game_detail_cannon20_express.a6d9ace7.jpg";